import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfPoint,
  PdfRect,
  PdfFont,
  PdfBrush,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutMultiGen } from '../layoutMulti';
import { OptsMulti } from '../optsMulti';
import { GUtil } from '../../pdf/gutil';
import { genMulti } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';

import { IItemCount } from '@educraft/base';

/**
 * Pisemka (Written Test / Quiz)
 *
 * Layout: Simple written test format with a title at the top,
 * then questions with multiple-choice answers filling the page dynamically.
 *
 * Migrated from C# EduFrame.Multi.Generators.Pisemka
 */
export class PisemkaTest implements ILayoutMultiGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsMulti): Promise<void> {
    const margin = PdfUnit.FromMillimeters(15);
    const itemHeight = PdfUnit.FromMillimeters(18);

    const font = new PdfFont(PdfFont.FONT_NAME, 12);
    const headFont = new PdfFont(PdfFont.FONT_NAME, 36);
    const topY = PdfUnit.FromMillimeters(40);

    const {lang} = opts.data;
    const headerText = (lang && lang.Pisemka_Header) ?? 'Exercise';

    const totalCount = this.countDefault();
    const gen = genMulti(opts.data, opts.generator, totalCount, false, false);

    let page = pdf.addPage();
    let pos = topY;

    // Draw title on first page
    page.drawString(
      headerText,
      headFont,
      PdfBrush.Black,
      null,
      new PdfRect(margin, topY - itemHeight, PdfSize.A4.width - 2 * margin, itemHeight),
      ETextAlign.CenterLeft
    );

    for (let i = 0; i < gen.length; i++) {
      const q = gen[i];

      // Calculate height needed for this question
      let requiredHeight = 0;
      for (const text of q.texts) {
        requiredHeight += page.measureString(text, font).height;
      }
      requiredHeight += itemHeight;

      // Check if it fits on current page
      if (pos + requiredHeight > PdfSize.A4.height - margin) {
        page = pdf.addPage();
        pos = margin;
      }

      // Draw question texts
      for (const text of q.texts) {
        const sz = page.measureString(text, font);
        page.drawString(
          text,
          font,
          PdfBrush.Black,
          null,
          new PdfRect(margin, pos, PdfSize.A4.width - 2 * margin, sz.height),
          ETextAlign.TopLeft
        );
        pos += sz.height;
      }

      // Draw answer options
      const colWidth = (PdfSize.A4.width - 2 * margin) / q.answers.length;
      for (let col = 0; col < q.answers.length; col++) {
        const label = `${String.fromCharCode(97 + col)}) ${q.answers[col]}`;
        page.drawString(
          label,
          font,
          PdfBrush.Black,
          null,
          new PdfRect(margin + col * colWidth, pos, colWidth, itemHeight),
          ETextAlign.TopLeft
        );
      }

      pos += itemHeight;
    }
  }
}
